<template>
  <div class="ce-searchResultTypeSelection">
    <button
      :class="{active: activeTab === 'overview'}"
      @click.prevent="setTab('overview')">
      {{ $t('formulationRepository.searchPage.tabs.overview') }}
    </button>

    <button
      v-if="activeUser"
      :class="{active: activeTab === 'favorites'}"
      @click.prevent="setTab('favorites')">
      {{ $t('formulationRepository.searchPage.tabs.myFormulations') }}
    </button>

    <tooltip
      class="disabled"
      v-else
      :content="$t('formulationRepository.favoriteAction.loginForFavorites')">
      <button
        class="disabled"
        @click.prevent>
        {{ $t('formulationRepository.searchPage.tabs.myFormulations') }}
      </button>
    </tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters(['activeTab']),
    ...mapState('user', ['activeUser']),
  },
  methods: {
    ...mapActions(['setTab'])
  }
};
</script>
